import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export const PageHeader = ({ eyebrow, title, description, crumbs = [], testId }) => (
  <div data-testid={testId} className="container-cc pt-10 lg:pt-16 pb-10 lg:pb-14">
    {crumbs.length > 0 && (
      <nav className="text-[11px] uppercase tracking-[0.18em] text-[#737373] flex items-center gap-2 mb-6">
        <Link to="/" className="hover:text-[#0A0A0A]">Acasă</Link>
        {crumbs.map((c, i) => (
          <span key={i} className="flex items-center gap-2">
            <span>/</span>
            {c.to ? <Link to={c.to} className="hover:text-[#0A0A0A]">{c.label}</Link> : <span className="text-[#0A0A0A]">{c.label}</span>}
          </span>
        ))}
      </nav>
    )}
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
      {eyebrow && <p className="eyebrow mb-3">{eyebrow}</p>}
      <h1 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tight">{title}</h1>
      {description && <p className="mt-4 text-sm sm:text-base text-[#5A5A5A] max-w-2xl leading-relaxed">{description}</p>}
    </motion.div>
  </div>
);
